import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    TgButtons2Module,
    TgDateTimeFormatterModule,
    TgGridModule,
    TgIconBasicInfoFramedModule,
    TgIconBasicMinusModule,
    TgIconBasicPlusModule,
    TgInfoBoxModule,
    TgRackModule
} from '@trademe/tangram';
import { SummaryPagePhotosMediaSectionModule } from '../../../sections/summary-page-sections/summary-page-photos-media-section/summary-page-photos-media-section.module';
import { SummaryPagePromotionsSectionModule } from '../../../sections/summary-page-sections/summary-page-promotions-section/summary-page-promotions-section.module';
import { SummaryPagePropertyDescriptionSectionModule } from '../../../sections/summary-page-sections/summary-page-property-description-section/summary-page-property-description-section.module';
import { SummaryPagePropertyInformationSectionModule } from '../../../sections/summary-page-sections/summary-page-property-information-section/summary-page-property-information-section.module';
import { SummaryPageRentalDetailsSectionModule } from '../../../sections/summary-page-sections/summary-page-rental-details-section/summary-page-rental-details-section.module';
import { SummaryPageSummarySectionModule } from '../../../sections/summary-page-sections/summary-page-summary-section/summary-page-summary-section.module';
import { SummaryPageValidationSummarySectionModule } from '../../../sections/summary-page-sections/summary-page-validation-summary-section/summary-page-validation-summary-section.module';
import { PropertySummaryPageComponent } from './property-summary-page.component';

@NgModule({
    imports: [
        CommonModule,
        SummaryPagePhotosMediaSectionModule,
        SummaryPagePromotionsSectionModule,
        SummaryPagePropertyDescriptionSectionModule,
        SummaryPagePropertyInformationSectionModule,
        SummaryPageRentalDetailsSectionModule,
        SummaryPageSummarySectionModule,
        SummaryPageValidationSummarySectionModule,
        TgButtons2Module,
        TgDateTimeFormatterModule,
        TgGridModule,
        TgGridModule,
        TgIconBasicInfoFramedModule,
        TgIconBasicMinusModule,
        TgIconBasicPlusModule,
        TgInfoBoxModule,
        TgRackModule,
        TgRackModule
    ],
    declarations: [PropertySummaryPageComponent],
    exports: [PropertySummaryPageComponent]
})
export class PropertySummaryPageModule {}
